module.exports = __webpack_public_path__ + "static/protonmail-c629ab1934607072e3dba8b5a7c9e907.png";